import { defineMessages } from 'react-intl';

export default defineMessages({
    driverx: {
        id: 'ml.quoteandbind.pup.additionalInterest.Driverx',
        defaultMessage: 'Driver {driverIndex}'
    },
    driverxExcluded: {
        id: 'ml.quoteandbind.pup.additionalInterest.driverxExcluded',
        defaultMessage: 'Excluded Driver {driverIndex}'
    },
    pupEmailAddress: {
        id: 'ml.quoteandbind.pup.additionalInformation.Email Address',
        defaultMessage: 'Email Address'
    },
    pupEmailAddressPlaceholder: {
        id: 'ml.quoteandbind.pup.additionalInformation.Enter email address',
        defaultMessage: 'Enter email address'
    },
    pupEmailAddressDesc: {
        id: 'ml.quoteandbind.pup.additionalInformation.Email address is required. Please re-enter to confirm.',
        defaultMessage: 'Email address is required. Please re-enter to confirm.'
    },
    pupOccupation: {
        id: 'ml.quoteandbind.pup.additionalInformation.Occupation',
        defaultMessage: 'Occupation'
    },
    occupationHelpTextTitle: {
        id: 'ml.quoteandbind.pup.additionalInformation.Why do you need my occupation?',
        defaultMessage: 'Why do you need my occupation?'
    },
    occupationHelpText: {
        id: 'ml.quoteandbind.pup.additionalInformation.occupationHelpText',
        defaultMessage: 'Where permissible by law, your occupation is one of the factors used in determining your rate, as well as, your eligibility for discounts.'
    },
    driversLicenseLabel: {
        id: 'ml.quoteandbind.pup.additionalInformation.Driver\'s License',
        defaultMessage: 'Driver\'s License'
    },
    addtlInterestPound: {
        id: 'ml.quoteandbind.pup.additionalInformation.pound',
        defaultMessage: '#'
    },
    stateLicensed: {
        id: 'ml.quoteandbind.pup.additionalInformation.State Licensed',
        defaultMessage: 'State Licensed'
    },
    stateLicensedTooltipLabel: {
        id: 'ml.quoteandbind.pup.additionalInformation.What if I don\'t have a US license?',
        defaultMessage: 'What if I don\'t have a US license?'
    },
    stateLicensedTooltipDesc: {
        id: 'ml.quoteandbind.pup.additionalInformation.Select DC, Canada, US Territories or Foreign as your state licensed.',
        defaultMessage: 'Select DC, Canada, US Territories or Foreign as your state licensed.'
    },
    ageFirstLicensed: {
        id: 'ml.quoteandbind.pup.additionalInformation.Age First Licensed',
        defaultMessage: 'Age First Licensed'
    }
});
